import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import AmazonStoreSelector from './AmazonStoreSelector';
import Burger from './Burger';
import { getPageGroupFromPath, trackInternalNavigationIfConsented } from './pageAnalytics';

const Navbar = ({ logged, userName }) => {
  const location = useLocation();
  const currentPageGroup = getPageGroupFromPath(location.pathname);

  return (
    <nav className="navbar">
      <NavLink
        to="/"
        style={{ textDecoration: 'none', color: 'inherit' }}
        onClick={() =>
          trackInternalNavigationIfConsented({
            link_target: '/',
            link_context: 'navbar_logo',
            source_page_group: currentPageGroup,
            destination_page_group: 'home',
          })
        }
      >
        <div className="logo">
          <span className="numbers">1</span>
          <span className="highlightn">0</span>
          <span className="numbers">1 </span>
          <span className="letters">S</span>
          <span className="highlightl">e</span>
          <span className="letters">tups</span>
        </div>
      </NavLink>
      <div className="navbar-controls">
        <AmazonStoreSelector />
        <Burger logged={logged} userName={userName} />
      </div>
    </nav>
  );
};

export default Navbar;
